import { ACTION, GenericObject, actionKeyGenerate } from "src/util/utils";

export const MODULE_KEY = "FTP_FILE_TRANSFER";

export const KEYS: GenericObject = actionKeyGenerate(MODULE_KEY);

export const FTP_FILE_TRANSFER_FETCH = KEYS[MODULE_KEY + ACTION.FETCH];

export const MOVE_TO_PROCESSPO = "MOVE_TO_PROCESSPO";
export const MOVE_TO_PROCESSPO_SUCCESS = "MOVE_TO_PROCESSPO_SUCCESS";
export const MOVE_TO_PROCESSPO_FAILED = "MOVE_TO_PROCESSPO_FAILED";

export const UPLOAD_TO_VENDORPO = "UPLOAD_TO_VENDORPO";
export const UPLOAD_TO_VENDORPO_SUCCESS = "UPLOAD_TO_VENDORPO_SUCCESS";
export const UPLOAD_TO_VENDORPO_FAILED = "UPLOAD_TO_VENDORPO_FAILED";


export const moveToProcessPO = (payload: any) => ({
  type: MOVE_TO_PROCESSPO,
  payload,
});

export const moveToProcessPOSuccess = (payload: any) => ({
  type: MOVE_TO_PROCESSPO_SUCCESS,
  payload,
});

export const moveToProcessPOFailed = (payload: any) => ({
  type: MOVE_TO_PROCESSPO_FAILED,
  payload,
});

export const uploadToVendorPO = (payload: any) => ({
  type: UPLOAD_TO_VENDORPO,
  payload,
});

export const uploadToVendorPOSuccess = (payload: any) => ({
  type: UPLOAD_TO_VENDORPO_SUCCESS,
  payload,
});

export const uploadToVendorPOFailed = (payload: any) => ({
  type: UPLOAD_TO_VENDORPO_FAILED,
  payload,
});